import { Modal, Title, Text, Button } from "@mantine/core";

export default function AdviceLockedModal({
  opened,
  close,
}: {
  opened: boolean;
  close: () => void;
}) {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      radius="lg"
      padding="xl"
      title={
        <Title order={4} ff={"var(--wallet-font-family-sambla-sans)"}>
          Ditt råd är låst
        </Title>
      }
    >
      <Text mb="lg">
        Du har ett aktivt råd som väntar på signering. Parametrarna kan inte
        längre ändras. Vänligen kontakta oss om du vill göra ändringar.
      </Text>
      <Button fullWidth onClick={close}>
        Jag förstår
      </Button>
    </Modal>
  );
}
